const ADDRESS_PROJECT_ID = 'delivery-and-invoice-addresses';
const CUSTOMER_DELIVERY_ADDRESS_API_ENDPOINT = '/checkout/app/api/state/v1/customer/addresses/delivery';
const CUSTOMER_TYPE = {
    NEW_CUSTOMER: 'NC',
    EXISTING_CUSTOMER: 'EC',
    GUEST_CUSTOMER: 'GC',
};

export { ADDRESS_PROJECT_ID, CUSTOMER_DELIVERY_ADDRESS_API_ENDPOINT, CUSTOMER_TYPE };
//# sourceMappingURL=constants.js.map
